import { Injectable } from '@angular/core';

/** Default filters configuration */
@Injectable()
export class FiltersConfig {
    debounce = 800;
}
